import {
	SvgIcon,
} from '@mui/material'

import GamesIcon from '@/shared/assets/icons/device-gamepad-2.svg?react'
import HomeIcon from '@/shared/assets/icons/home.svg?react'
import ProfileIcon from '@/shared/assets/icons/user.svg?react'
import ClubsIcon from '@/shared/assets/icons/users-group.svg?react'
import {
	AppRouterKeys,
} from '@/shared/model/constants'

import type {
	IBottomNavigationItem,
} from '../types'

export const bottomNavigationConfig: Array<IBottomNavigationItem> = [
	{
		key:       'home',
		path:      AppRouterKeys.HOME,
		icon:     (
			<SvgIcon
				fontSize='small'
				sx={{
					color: 'inherit',
				}}
			>
				<HomeIcon />
			</SvgIcon>
		),
		label:     'Главная',
		showLabel: true,
	},
	{
		key:       'clubs',
		path:      AppRouterKeys.CLUBS,
		icon:      (
			<SvgIcon
				fontSize='small'
				sx={{
					color: 'inherit',
				}}
			>
				<ClubsIcon />
			</SvgIcon>
		),
		label:     'Клубы',
		showLabel: true,
	},
	{
		key:       'games',
		path:      AppRouterKeys.GAMES,
		icon:      (
			<SvgIcon
				fontSize='small'
				sx={{
					color: 'inherit',
				}}
			>
				<GamesIcon />
			</SvgIcon>
		),
		label:     'Комнаты',
		showLabel: true,
	},
	{
		key:       'profile',
		path:      AppRouterKeys.MY_PROFILE,
		icon:      (
			<SvgIcon
				fontSize='small'
				sx={{
					color: 'inherit',
				}}
			>
				<ProfileIcon />
			</SvgIcon>
		),
		label:     'Профиль',
		showLabel: true,
	},
]
